const ArrowDownIcon = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 7.5L10.5 13.5L4.5 7.5" stroke="#002030" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="round"/>
        </svg>
    );
}

export default ArrowDownIcon;
